/** Слои z-index интерфейса владельца. Счётчик плавающих окон (`nextZIndex`) стартует с 1000 и
 *  растёт на каждую смену фокуса между окнами, поэтому база всех попапов antd (Tooltip, Dropdown,
 *  Select, DatePicker, Modal) — на порядки выше: иначе после сотен переключений окон (в том числе
 *  горячими клавишами) окно перекрыло бы свою же подсказку или выпадающий список. */
export const POPUP_Z_INDEX_BASE = 1_000_000;

/** Панель свёрнутых окон: над окнами, под любыми попапами и диалогами. */
export const TASKBAR_Z_INDEX = 100_000;

/** Телефон (< 768px): шапка и нижняя панель вкладок владельца — ПОД листами-окнами (их z-index
 *  стартует с 1000): лист закрывает весь экран, включая панель вкладок. */
export const MOBILE_BAR_Z_INDEX = 900;

/** Телефон: высота нижней панели вкладок без отступа под «домашнюю» полосу (`safe-area-inset-bottom`). */
export const MOBILE_TAB_BAR_HEIGHT = 56;

/** Телефон: высота ленты свёрнутых окон (кнопки 40px + отступы 8px + рамка 1px) — над панелью вкладок. */
export const MOBILE_TASKBAR_HEIGHT = 57;
